// @ts-nocheck
import Pagination from "@insite/mobius/Pagination";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import React, { FC, useState } from "react";

const StyleguidePaginations: FC = () => {
    const [sectionId] = useState(`section-${uniqueId()}`);
    const [pagination, setPagination] = useState({
        resultsCount: 150,
        page: 1,
        pageSize: 12,
        pageSizeOptions: [8, 16, 24, 32],
    });

    const changePage = (newPageIndex: number) => {
        setPagination({
            ...pagination,
            page: newPageIndex,
        });
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        setPagination({
            ...pagination,
            page: 1,
            pageSize: newPageSize,
        });
    };

    return (
        <StyleguideSection title="Paginations" sectionId={sectionId}>
            <Pagination
                currentPage={pagination.page}
                resultsPerPage={pagination.pageSize}
                resultsPerPageOptions={pagination.pageSizeOptions}
                resultsCount={pagination.resultsCount}
                onChangePage={changePage}
                onChangeResultsPerPage={changeResultsPerPage}
            />
        </StyleguideSection>
    );
};

export default StyleguidePaginations;
